import { motion, useReducedMotion } from "framer-motion";
import { Link } from "react-router-dom";
import Offer1 from "../../../assets/images/offer1.png";
import Offer2 from "../../../assets/images/offer2.png";

const MotionLink = motion.create(Link);

const offerCards = [
  {
    id: "offer-50",
    image: Offer2,
    title: "50% off your first order",
    expiryClass: "text-xs text-heading",
    buttonClass:
      "mt-16 btn bg-success-600 hover-text-white hover-bg-success-700 text-white fw-medium d-inline-flex align-items-center rounded-pill gap-8",
    contentClass: "py-xl-4 max-w-392 ms-auto",
  },
  {
    id: "offer-20",
    image: Offer1,
    title: "20% off your first order",
    expiryClass: "text-sm text-success-600",
    buttonClass:
      "mt-16 btn bg-white hover-text-white hover-bg-main-800 text-heading fw-medium d-inline-flex align-items-center rounded-pill gap-8",
    contentClass: "py-xl-4 max-w-392",
  },
];

const OfferBanner = () => {
  const shouldReduceMotion = useReducedMotion();

  const sectionVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.12,
        delayChildren: shouldReduceMotion ? 0 : 0.08,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 18 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.6,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  const contentVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.45,
        delay: shouldReduceMotion ? 0 : 0.1,
      },
    },
  };

  return (
    <section className="offer pt-80 mb-80">
      <div className="container container-lg">
        <motion.div
          className="row gy-4"
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
        >
          {offerCards.map((card) => (
            <motion.div
              key={card.id}
              className="col-sm-6"
              variants={cardVariants}
              whileHover={
                shouldReduceMotion
                  ? undefined
                  : {
                      y: -4,
                      transition: { duration: 0.25, ease: "easeOut" },
                    }
              }
            >
              <motion.div
                className="offer-card position-relative rounded-16 overflow-hidden p-16 ps-56-px"
                whileHover={
                  shouldReduceMotion
                    ? undefined
                    : {
                        scale: 1.01,
                        transition: { duration: 0.25, ease: "easeOut" },
                      }
                }
              >
                <motion.img
                  src={card.image}
                  alt=""
                  className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100"
                  whileHover={
                    shouldReduceMotion
                      ? undefined
                      : {
                          scale: 1.04,
                          transition: { duration: 0.45, ease: "easeOut" },
                        }
                  }
                />
                <motion.div className={card.contentClass} variants={contentVariants}>
                  <motion.div
                    className="offer-card__logo mb-16 w-80 h-80 flex-center bg-white rounded-circle"
                    whileHover={
                      shouldReduceMotion
                        ? undefined
                        : {
                            rotate: 6,
                            transition: { duration: 0.25 },
                          }
                    }
                  >
                    <img src="../assets/images/thumbs/offer-logo.png" alt="" />
                  </motion.div>
                  <h5 className="mb-8">{card.title}</h5>
                  <div className="flex-align gap-8">
                    <span className="text-sm fw-medium text-heading">
                      Delivery by 6:15am
                    </span>
                    <span className={card.expiryClass}>Expire Aug 5</span>
                  </div>
                  <MotionLink
                    to="/collections"
                    className={card.buttonClass}
                    tabIndex={0}
                    whileTap={shouldReduceMotion ? undefined : { scale: 0.98 }}
                    whileHover={
                      shouldReduceMotion
                        ? undefined
                        : {
                            y: -1,
                            transition: { duration: 0.2, ease: "easeOut" },
                          }
                    }
                  >
                    Shop Now
                    <motion.span
                      className="icon text-xl d-flex"
                      animate={
                        shouldReduceMotion
                          ? undefined
                          : {
                              x: [0, 3, 0],
                            }
                      }
                      transition={{
                        duration: 1.8,
                        repeat: Infinity,
                        ease: "easeInOut",
                        repeatDelay: 1.2,
                      }}
                    >
                      <i className="ph ph-arrow-right" />
                    </motion.span>
                  </MotionLink>
                </motion.div>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
export default OfferBanner;
